export default __webpack_public_path__ + "static/media/program-6.5b0ac64d.jpg";